import { Avatar } from '@mui/material';
import { useParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { getAbsoluteFileUrl, normalizeFIO } from 'src/app/helpers/utils';
import { useGetDataForVisitCardQuery } from 'src/app/services/staffApi';

const ContactPage = () => {
  const { id } = useParams();
  const { data: empl = null } = useGetDataForVisitCardQuery({ id }, { skip: !id });

  return (
    <div
      className="h-full w-full flex items-center justify-center bg-repeat bg-top "
      style={{ background: '#153776', }}
    >
      {empl && (
        <div
          className="relative flex flex-col sm:flex-row items-center gap-20 m-14 bg-white shadow-2 hover:shadow-4 hover:shadow-white transition-shadow shadow-white rounded-lg p-10 w-full max-w-2xl overflow-hidden bg-cover"
          style={{ background: "#fff" }}
        >
          <motion.div initial={{ scale: 0 }} animate={{ scale: 1, transition: { delay: 0.1 } }}>
            <a href={`https://${process.env.REACT_APP_COMPANY_SITE_URI}`}>
              <img
                className="logo-icon w-[175px] h-32 mb-14"
                src={`assets/images/logo/${process.env.REACT_APP_COMPANY_NAME}/logo-with-text.svg`}
                alt="logo"
              />
            </a>
            <div className="flex justify-center">
              <Avatar
                sx={{ borderRadius: '50%' }}
                className="w-128 h-128 rounded-12 text-32 font-bold "
                src={getAbsoluteFileUrl(empl?.photo)}
              />
            </div>
            <a
              href={`https://${process.env.REACT_APP_COMPANY_SITE_URI}`}
              className="hidden sm:block text-center text-grey mt-10 no-underline"
            >
              {process.env.REACT_APP_COMPANY_SITE_URI}
            </a>
          </motion.div>

          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1, transition: { delay: 0.3 } }}
            className="relative text-center sm:text-left mt-20"
          >
            <span className=""></span>
            <h2 className="text-24 font-semibold text-[#153776]">
              {empl?.name && normalizeFIO(`${empl?.surname} ${empl?.name} ${empl?.patronymic}`)}
            </h2>
            {empl?.position && <p className="text-gray-600 text-18">{empl?.position}</p>}
            <div className="mt-24">
              {empl?.phone && (
                <div className="flex flex-wrap text-gray-800">
                  <div className="font-medium mr-6 text-grey">Телефон:</div>
                  <a href={`tel:${empl.phone}`} className="text-blue-500 hover:underline">
                    {empl.phone}
                  </a>
                </div>
              )}
              {empl?.email && (
                <div className="flex flex-wrap mt-2 text-grey">
                  <div className="font-medium mr-6 text-grey">Email:</div>
                  <a href={`mailto:${empl.email}`} className="ml-6">
                    {empl.email.toLowerCase()}
                  </a>
                </div>
              )}
            </div>
            <a
              href={`https://${process.env.REACT_APP_COMPANY_SITE_URI}`}
              className="block sm:hidden text-center text-grey mt-10"
            >
              {process.env.REACT_APP_COMPANY_SITE_URI}
            </a>
          </motion.div>
        </div>
      )}
    </div>
  );
};

export default ContactPage;
